<template>
  <div>
    <div class="background-loader" v-if="isLoadingApi">
      <div class="loaderItem"></div>
    </div>
    <div class="container pl-4 pr-4">
      <div class="mb-4">
        <Navigation />
      </div>
      <router-view />
    </div>
  </div>
</template>
<style>
.background-loader {
  position: fixed;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.loaderItem {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 5rem;
  height: 5rem;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

/* Buefy mặc định max-width 460px, nới thêm 50px */
.dialog.jc-pack-notice .modal-card {
  max-width: 510px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<script>
export default {
  components: {
    Navigation: () => import('@/components/Navigation.vue'),
  },
  computed: {
    isLoadingApi() {
      return this.$store.state.isLoadingApi;
    },
  },
  mounted() {
    this.showJcPackMigrationNotice();
  },
  methods: {
    showJcPackMigrationNotice() {
      const url = 'https://staging.jc-package.vi-mash.com/manage/transport';
      const link = `<br><a href="${url}" target="_blank" rel="noopener noreferrer">JC PACKAGE SYSTEM</a>`;
      this.$buefy.dialog.alert({
        title: 'お知らせ',
        message:
          '「JC PACK」に移行しております。何も問題がない場合は、以下のリンク先で業務実施してください。' +
          link,
        // Buefy dialog chỉ gắn `size` vào class gốc, dùng làm class riêng để chỉnh độ rộng
        size: 'jc-pack-notice',
        type: 'is-info',
        hasIcon: true,
        icon: 'exclamation-triangle',
        iconPack: 'fa',
        confirmText: 'OK',
        ariaRole: 'alertdialog',
        ariaModal: true,
      });
    },
  },
};
</script>
